module.exports = __webpack_public_path__ + "img/go4.d10e83d8.png";